import { useState, useEffect } from "react";
import { NAV_LINKS } from "@/data/content";
import { Menu, X } from "lucide-react";

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const target = document.querySelector(href);
    if (target && window.__lenis) {
      window.__lenis.scrollTo(target, { offset: -20, duration: 1.3 });
    } else if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-[#141414]/10 py-4"
          : "bg-transparent py-6"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          onClick={(e) => go(e, "#top")}
          className="font-display text-xl md:text-2xl leading-none tracking-tight text-[#141414] hover:text-[#1f3d2b] transition-colors duration-300"
        >
          Morten Junge Bertelsen
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              onClick={(e) => go(e, l.href)}
              className="font-ui text-[11px] uppercase tracking-[0.22em] text-[#6f6f6a] hover:text-[#1f3d2b] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden text-[#141414] p-1"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <nav
          data-testid="nav-mobile-menu"
          className="md:hidden bg-white/98 backdrop-blur-xl border-t border-[#141414]/10 mt-4"
        >
          <div className="flex flex-col px-6 py-6 gap-5">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-mobile-link-${l.href.replace("#", "")}`}
                onClick={(e) => go(e, l.href)}
                className="font-ui text-sm uppercase tracking-[0.22em] text-[#2a2a28] hover:text-[#1f3d2b] transition-colors"
              >
                {l.label}
              </a>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
};
